(() => {
  'use strict';
  const root = document.documentElement;
  root.classList.add('js-motion');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let paused = false;
  try { paused = localStorage.getItem('mw-motion-paused') === '1'; } catch (_) {}
  const enabled = () => root.dataset.motion !== 'off' && !paused && !reduced.matches;
  const syncMotion = () => {
    root.classList.toggle('motion-paused', paused);
    root.classList.toggle('motion-reduced', reduced.matches);
    document.querySelectorAll('[data-motion-toggle]').forEach(button => {
      button.hidden = root.dataset.motion === 'off';
      button.disabled = reduced.matches;
      button.setAttribute('aria-pressed', String(paused || reduced.matches));
      button.textContent = reduced.matches ? 'Movimento ridotto attivo' : paused ? 'Riprendi le animazioni' : 'Metti in pausa le animazioni';
    });
  };
  document.addEventListener('click', event => {
    if (event.target.closest('[data-motion-toggle]')) {
      paused = !paused;
      try { localStorage.setItem('mw-motion-paused', paused ? '1' : '0'); } catch (_) {}
      syncMotion();
    }
    const mobileLink = event.target.closest('.mobile-nav a');
    if (mobileLink) mobileLink.closest('details').open = false;
    document.querySelectorAll('.mobile-nav[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.mobile-nav[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
  reduced.addEventListener('change', syncMotion);
  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); }
  }), {threshold: 0.08}) : null;
  // Simplified geographic outlines: longitude, latitude. A dot surface keeps the globe light.
  const land = [
    [[-168,66],[-153,71],[-140,70],[-130,60],[-122,54],[-126,48],[-123,40],[-116,32],[-108,27],[-103,21],[-97,16],[-91,18],[-86,21],[-82,24],[-81,30],[-76,35],[-68,45],[-60,48],[-62,55],[-75,61],[-87,66],[-100,72],[-122,73],[-141,70]],
    [[-81,12],[-72,11],[-64,8],[-52,4],[-35,-6],[-39,-18],[-48,-28],[-54,-35],[-65,-55],[-73,-51],[-73,-35],[-80,-6]],
    [[-53,59],[-42,60],[-21,72],[-28,82],[-48,84],[-62,77]],
    [[-11,36],[-10,43],[-2,48],[6,53],[9,58],[5,62],[16,71],[31,71],[40,64],[51,55],[41,42],[28,41],[25,36],[18,40],[12,44],[6,43],[2,37]],
    [[-17,34],[-6,36],[10,37],[25,32],[33,31],[37,23],[44,12],[51,11],[42,-2],[39,-13],[32,-29],[18,-35],[11,-17],[9,1],[-3,5],[-16,13]],
    [[30,70],[59,74],[88,77],[111,74],[140,70],[177,65],[173,55],[153,58],[141,46],[130,43],[125,32],[121,22],[110,20],[106,7],[101,1],[95,5],[90,22],[80,7],[72,22],[62,25],[55,17],[43,13],[37,29],[35,43],[45,56]],
    [[112,-11],[131,-12],[138,-10],[153,-25],[150,-38],[132,-35],[115,-35],[112,-25]],
    [[47,-13],[50,-16],[47,-26],[43,-24]],[[130,32],[136,34],[142,43],[145,44],[140,34],[132,30]],[[95,5],[105,-5],[119,-9],[130,-8],[118,-4],[108,0]],[[166,-35],[179,-40],[173,-47],[167,-46]], [[-10,50],[-5,50],[-3,59],[-7,58]]
  ];
  function inside(x,y,poly) { let hit=false; for(let i=0,j=poly.length-1;i<poly.length;j=i++) {const a=poly[i],b=poly[j];if(((a[1]>y)!==(b[1]>y)) && (x<(b[0]-a[0])*(y-a[1])/(b[1]-a[1])+a[0]))hit=!hit;}return hit; }
  const rad = Math.PI/180;
  const dots=[];
  for(let lat=-54;lat<=80;lat+=3) for(let lon=-180;lon<180;lon+=3.4/Math.max(.3,Math.cos(lat*rad))) if(land.some(poly=>inside(lon,lat,poly))) dots.push([lon*rad,lat*rad]);
  const globes = new Map();
  function createGlobe(stage) {
    if(globes.has(stage))return;
    const canvas=stage.querySelector('canvas'),ctx=canvas.getContext('2d'); if(!ctx)return;
    const label=stage.querySelector('.orbit-label');
    const color=getComputedStyle(root).getPropertyValue('--accent').trim() || '#80ff97';
    const g={stage,canvas,ctx,label,color,time:0,visible:true,w:0,h:0,r:0,last:0};
    const resize=()=>{const size=canvas.parentElement.clientWidth;const dpr=Math.min(devicePixelRatio||1,1.75);canvas.width=Math.round(size*dpr);canvas.height=canvas.width;g.w=stage.clientWidth;g.h=stage.clientHeight;g.r=canvas.width*.46;draw(g);};
    canvas.hidden=false;stage.querySelector('.globe-fallback').hidden=true;
    g.resizeObserver=new ResizeObserver(resize);g.resizeObserver.observe(stage);
    g.observer=new IntersectionObserver(entries=>{g.visible=entries[0].isIntersecting;});g.observer.observe(stage);
    globes.set(stage,g);resize();
  }
  function draw(g){
    const {ctx,canvas,r,color}=g,c=canvas.width/2;
    const rotation=.15+g.time*.000095;
    const project=(lon,lat)=>{const x=Math.cos(lat)*Math.sin(lon+rotation),y=-Math.sin(lat),z=Math.cos(lat)*Math.cos(lon+rotation); const tilt=.16; return [c+r*x,c+r*(y*Math.cos(tilt)+z*Math.sin(tilt)),z*Math.cos(tilt)-y*Math.sin(tilt)];};
    ctx.clearRect(0,0,canvas.width,canvas.height);
    const shade=ctx.createRadialGradient(c-r*.35,c-r*.4,r*.06,c,c,r);
    shade.addColorStop(0,'#244532');shade.addColorStop(.55,'#10241a');shade.addColorStop(1,'#060d09');
    ctx.beginPath();ctx.arc(c,c,r,0,Math.PI*2);ctx.fillStyle=shade;ctx.fill();
    ctx.strokeStyle=color;ctx.lineWidth=Math.max(.6,canvas.width/650);ctx.globalAlpha=.14;
    const line=points=>{ctx.beginPath();let drawing=false;points.forEach(([lo,la])=>{let [x,y,z]=project(lo,la);if(z>0){drawing?ctx.lineTo(x,y):ctx.moveTo(x,y);drawing=true;}else drawing=false;});ctx.stroke();};
    for(let lat=-60;lat<=60;lat+=30){const pts=[];for(let lon=-180;lon<=180;lon+=4)pts.push([lon*rad,lat*rad]);line(pts);}
    for(let lon=0;lon<360;lon+=30){const pts=[];for(let lat=-90;lat<=90;lat+=4)pts.push([lon*rad,lat*rad]);line(pts);}
    ctx.fillStyle=color;
    dots.forEach(([lo,la])=>{const [x,y,z]=project(lo,la);if(z<=0)return;ctx.globalAlpha=.28+.62*z;ctx.beginPath();ctx.arc(x,y,Math.max(.7,r*.0065*(.65+.35*z)),0,Math.PI*2);ctx.fill();});
    ctx.globalAlpha=.4;ctx.strokeStyle=color;ctx.lineWidth=1;ctx.beginPath();ctx.arc(c,c,r,0,Math.PI*2);ctx.stroke();ctx.globalAlpha=1;
    const a=.52+g.time*.00013;
    const rx=Math.max(20,(g.w-g.label.offsetWidth-26)/2);
    const x=rx*Math.cos(a),y=g.h*.19*Math.sin(a)-x*.20,depth=Math.sin(a);
    g.label.style.transform=`translate(-50%,-50%) translate(${x}px,${y}px) scale(${.9+.1*depth})`;
    g.label.style.zIndex=depth>=0?'3':'1';
    g.label.dataset.orbitSide=depth>=0?'front':'back';
    g.label.style.opacity=String(.86+.14*(depth+1)/2);
  }
  let previous=0, knownReduction=reduced.matches;
  const tick=now=>{if(knownReduction!==reduced.matches){knownReduction=reduced.matches;syncMotion();}const delta=Math.min(50,now-(previous||now));previous=now;globes.forEach((g,el)=>{if(!el.isConnected){g.resizeObserver.disconnect();g.observer.disconnect();globes.delete(el);return;}if(enabled()&&g.visible&&!document.hidden){g.time+=delta;if(now-g.last>32){draw(g);g.last=now;}}});requestAnimationFrame(tick);};
  function init(scope=document){
    syncMotion();
    scope.querySelectorAll('.reveal').forEach(el=>revealObserver?.observe(el));
    scope.querySelectorAll('[data-globe]').forEach(createGlobe);
    scope.querySelectorAll('[data-variant-select]').forEach(select=>{
      if(select.dataset.ready)return;select.dataset.ready='true';
      select.addEventListener('change',()=>{
        const option=select.selectedOptions[0],section=select.closest('[data-product-section]');
        section.querySelector('[data-product-price]').textContent=option.dataset.price;
        const compare=section.querySelector('[data-compare-price]');compare.hidden=!option.dataset.compare;compare.querySelector('s').textContent=option.dataset.compare||'';
        const button=section.querySelector('[data-add-to-cart]');button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?'Esaurito':button.dataset.label;
        section.querySelectorAll('[data-media-id]').forEach(media=>media.toggleAttribute('data-current-media',media.dataset.mediaId===option.dataset.media));
        const next=new URL(location.href);next.searchParams.set('variant',select.value);history.replaceState({},'',next);
      });
    });
  }
  init();requestAnimationFrame(tick);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
